import { render, staticRenderFns } from "./u-dialog-color-bg-tile.vue?vue&type=template&id=fb9d3382&scoped=true"
import script from "./u-dialog-color-bg-tile.vue?vue&type=script&lang=js"
export * from "./u-dialog-color-bg-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9d3382",
  null
  
)

export default component.exports